export const isInteractionMatchedInbox = (interaction, inbox) => {
  if(
    !interaction ||
    !inbox ||
    !interaction.takeover
  ) {
    return false
  }

  if(
    inbox.inboxType === 'channelId' &&
    Array.isArray(interaction.threads) &&
    interaction.threads.length > 0
  ) {
    const { channelId } = interaction.threads[0]

    return channelId === inbox.inboxValue
  }
}
